/**
 * @typedef {Object} Totals
 * @property {Number} totalExcVat - The total excluding VAT
 * @property {Number} totalVat - The total VAT
 * @property {Number} totalIncVat - The total including VAT
 */
export const scrollToTop = () =>
  setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0);
